import DataGrid from '@/components/elements/lists/DataGrid';
import { _t } from '@/locale';

type Props = {
  baseTranslationKey:
    | 'components.modules.checkout.CheckoutDetails'
    | 'components.modules.appointment.AppointmentDetailsSummary';
  subtotal?: string;
};

const PaymentDetailsSubtotal = ({ subtotal, baseTranslationKey }: Props) => {
  if (!subtotal) {
    return null;
  }

  return (
    <DataGrid.Row hasPaddingTop>
      <DataGrid.Cell title={_t(`${baseTranslationKey}.subtotal.label`)} type="description" />
      <DataGrid.Cell
        title={subtotal}
        type="description"
        align="right"
        ariaLabel={_t(`${baseTranslationKey}.subtotal.label`)}
      />
    </DataGrid.Row>
  );
};

export default PaymentDetailsSubtotal;
